export const getMemberHeroCmsSelector = (state) => state?.admin?.member_hero_cms;
export const getMemberCmsSelector = (state) => state?.admin?.member_cms;
